import { countiesNI } from '../constants/counties';
import { CURRENCIES, Currency } from '../types';

/**
 * A function that takes a county as a string and returns the currency based on the county
 * @param county a county
 * @returns correctly formatted currency
 */
export const getCurrencyBasedOnCounty = (county: string): Currency => {
  if (county && countiesNI.includes(county)) {
    return CURRENCIES.GBP;
  } else return CURRENCIES.EUR;
};
